/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkbookTaskItemDto,
    WorkbookTaskItemDtoFromJSON,
    WorkbookTaskItemDtoFromJSONTyped,
    WorkbookTaskItemDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkbookTaskDto
 */
export interface WorkbookTaskDto {
    /**
     * 
     * @type {string}
     * @memberof WorkbookTaskDto
     */
    reasonId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookTaskDto
     */
    statusId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkbookTaskDto
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkbookTaskDto
     */
    workbookId?: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkbookTaskDto
     */
    statechangedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkbookTaskDto
     */
    statechangedBy?: string | null;
    /**
     * 
     * @type {Array<WorkbookTaskItemDto>}
     * @memberof WorkbookTaskDto
     */
    items?: Array<WorkbookTaskItemDto> | null;
}

export function WorkbookTaskDtoFromJSON(json: any): WorkbookTaskDto {
    return WorkbookTaskDtoFromJSONTyped(json, false);
}

export function WorkbookTaskDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkbookTaskDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reasonId': !exists(json, 'reasonId') ? undefined : json['reasonId'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'workbookId': !exists(json, 'workbookId') ? undefined : json['workbookId'],
        'statechangedDate': !exists(json, 'statechangedDate') ? undefined : (json['statechangedDate'] === null ? null : new Date(json['statechangedDate'])),
        'statechangedBy': !exists(json, 'statechangedBy') ? undefined : json['statechangedBy'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(WorkbookTaskItemDtoFromJSON)),
    };
}

export function WorkbookTaskDtoToJSON(value?: WorkbookTaskDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reasonId': value.reasonId,
        'statusId': value.statusId,
        'taskId': value.taskId,
        'workbookId': value.workbookId,
        'statechangedDate': value.statechangedDate === undefined ? undefined : (value.statechangedDate === null ? null : value.statechangedDate.toISOString()),
        'statechangedBy': value.statechangedBy,
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(WorkbookTaskItemDtoToJSON)),
    };
}


